import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import NavbarNew from './components/NavbarNew';
import HomeNew from './pages/HomeNew';
import Products from './pages/Products';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import OrderConfirmation from './pages/OrderConfirmation';
import MyOrders from './pages/MyOrders';
import Profile from './pages/Profile';
import AdminDashboard from './admin/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import TokenGate from './components/TokenGate';
import ScrollToTop from './components/ScrollToTop';
import PasswordGate from './components/PasswordGate';
import UserLogin from './pages/UserLogin';
import UserRegister from './pages/UserRegister';
import About from './pages/About';
import Contact from './pages/Contact';

function AppContent() {
  const location = useLocation();
  const isSecretPanel = location.pathname === '/secret-panel';
  const isAdminLogin = location.pathname === '/admin-login';
  const isUserLogin = location.pathname === '/user-login';
  const isUserRegister = location.pathname === '/user-register';

  return (
    <>
      {!isSecretPanel && !isAdminLogin && !isUserLogin && !isUserRegister && <NavbarNew />}
      <Routes>
        <Route path="/" element={<HomeNew />} />
        <Route path="/products" element={<Products />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/user-register" element={<UserRegister />} />
        <Route
          path="/admin-login"
          element={
            <TokenGate>
              <PasswordGate>
                <AdminLogin />
              </PasswordGate>
            </TokenGate>
          }
        />
        <Route
          path="/secret-panel"
          element={
            <PasswordGate>
              <AdminDashboard />
            </PasswordGate>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
